var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from 'react';
import dayjs from 'dayjs';
import styled from 'styled-components';
import relative from 'dayjs/plugin/relativeTime';
import cx from 'classnames';
dayjs.extend(relative);
const StyledTime = styled.time `
  font-size: 12px;
  color: ${(props) => props.type === 'secondary' ? 'var(--text-color-2)' : 'var(--text-color-0)'};
`;
export const Date = (_a) => {
    var { type = 'default', className } = _a, props = __rest(_a, ["type", "className"]);
    const children = useMemo(() => {
        if (props.relative) {
            return dayjs(props.value).toNow();
        }
        const year = dayjs().year();
        const yearOfValue = dayjs(props.value).year();
        if (year === yearOfValue) {
            return dayjs(props.value).format(props.showTime ? 'MM/DD HH:mm:ss' : 'MM/DD');
        }
        return dayjs(props.value).format(props.showTime ? 'YYYY/MM/DD HH:mm:ss' : 'YYYY/MM/DD');
    }, [props.value, props.relative, props.showTime]);
    return (React.createElement(StyledTime, Object.assign({ className: cx('date', className), type: type }, props), children));
};
